import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Search, Loader2, LayoutGrid, ChevronRight } from 'lucide-react';
import { API } from '../config/apiBase';
import {
    Smartphone, Tv, Laptop, Gamepad2, Refrigerator, Shirt, User,
    Sparkles, Home, Dumbbell, Baby, ToyBrick, BookOpen, ShoppingCart,
    Car, Wrench, PawPrint, Plane, Ticket, Gift,
    Heart, Hammer, Truck, Building2, Factory, Briefcase,
    Speaker, Tag
} from 'lucide-react';


const iconMap = {
    Smartphone, Tv, Laptop, Gamepad2, Refrigerator, Shirt, User,
    Sparkles, Home, Dumbbell, Baby, ToyBrick, BookOpen, ShoppingCart,
    Car, Wrench, PawPrint, Plane, Ticket, Gift,
    Heart, Hammer, Truck, Building2, Factory, Briefcase,
    Speaker, Tag
};

export default function CategoriesPage() {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        fetch(`${API}/categories`)
            .then(r => r.json())
            .then(data => setCategories(data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const filtered = categories.filter(c =>
        !searchQuery || c.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="min-h-screen" style={{ background: 'var(--bg)' }} data-testid="categories-page">
            <div className="site-container mx-auto px-4 sm:px-6 lg:px-8 py-6">
                {/* Header */}
                <div className="flex items-center gap-3 mb-6">
                    <LayoutGrid className="w-5 h-5" style={{ color: 'var(--gold-2)' }} />
                    <h1 className="text-xl font-outfit font-bold" style={{ color: 'var(--text)' }}>Categorias</h1>
                </div>

                {/* Search */}
                <div className="relative mb-6">
                    <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4" style={{ color: 'var(--muted-2)' }} />
                    <input
                        type="text"
                        placeholder="Buscar categoria..."
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                        className="search-input w-full pl-11 pr-4 py-3 text-sm"
                        data-testid="category-search"
                    />
                </div>

                {loading ? (
                    <div className="flex justify-center py-20">
                        <Loader2 className="w-8 h-8 animate-spin" style={{ color: 'var(--gold-2)' }} />
                    </div>
                ) : (
                    <>
                        {/* All categories link */}
                        <Link
                            to="/"
                            className="flex items-center justify-between p-4 rounded-xl mb-2 transition-colors hover:bg-[var(--surface-3)]"
                            style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
                            data-testid="category-all-link"
                        >
                            <div className="flex items-center gap-3">
                                <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'var(--gold-bg)' }}>
                                    <LayoutGrid className="w-5 h-5" style={{ color: 'var(--gold-2)' }} />
                                </div>
                                <span className="text-sm font-medium" style={{ color: 'var(--text)' }}>Todas as ofertas</span>
                            </div>
                            <ChevronRight className="w-4 h-4" style={{ color: 'var(--muted-2)' }} />
                        </Link>

                        {/* Categories grid */}
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                            {filtered.map(cat => {
                                const Icon = iconMap[cat.icon] || Ticket;
                                return (
                                    <Link
                                        key={cat.category_id}
                                        to={`/?categoria=${cat.category_id}`}
                                        className="flex items-center justify-between p-4 rounded-xl transition-colors hover:bg-[var(--surface-3)]"
                                        style={{ background: 'var(--surface)', border: '1px solid var(--border)' }}
                                        data-testid={`cat-${cat.slug}`}
                                    >
                                        <div className="flex items-center gap-3">
                                            <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ background: 'var(--surface-2)' }}>
                                                <Icon className="w-5 h-5" style={{ color: 'var(--gold-2)' }} />
                                            </div>
                                            <div>
                                                <p className="text-sm font-medium" style={{ color: 'var(--text)' }}>{cat.name}</p>
                                                {cat.description && (
                                                    <p className="text-[10px] mt-0.5" style={{ color: 'var(--muted-2)' }}>{cat.description}</p>
                                                )}
                                            </div>
                                        </div>
                                        <ChevronRight className="w-4 h-4 flex-shrink-0" style={{ color: 'var(--muted-2)' }} />
                                    </Link>
                                );
                            })}
                        </div>

                        {filtered.length === 0 && (
                            <div className="text-center py-12">
                                <p style={{ color: 'var(--muted)' }}>Nenhuma categoria encontrada</p>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
